module.exports = __webpack_public_path__ + "img/letitia-still.4aa66cc9.png";